import Axios from "../../Lib/Axios";
export const listArticle = (page) => {
    return Axios.get(`news/${page}`);
}

export const detailArticle = (slug) => {
    return Axios.get(`news/detail/${slug}`);
}